module.exports = __webpack_public_path__ + "static/img/folder.ac33e4a0.jpg";